<template>

<div id="dashboard">
  <div v-if="!states.viewAllow && !states.showFail" class="loader overlay">
    <img class="overlay-container" src="@/assets/img/loader.gif" />
  </div>
  <div v-if="states.showFail">
    <p></p>
      <div v-if="states.onServerError" class="text-center">
      <label>Došlo k neočakávanej chybe. Skúste neskôr.</label>
      </div>
      <div v-else>
      <p class="text-center" v-if="tplData.general"><label v-html="tpl('general.errorLoading')"></label></p>
      </div>
  </div>
  <div v-if="states.viewAllow && states.mainView">
      <div class="row" v-if="states.isPecka">
        <div v-if="states.rplnRel == 'P'">
        <div class="large-12 medium-12 small-12 columns"><p></p>
        <div  v-if="showTypes['top'] && pkgTypes.top[0]">
        <h2 v-text="pkgTypes.top[0].readable"></h2>
            <div v-for="pcg in pkgTypes.top" :key="pcg.bucketName">
                <div class='x-pecka' v-bind:class="{ 'pcg_list_w': pcg.bucketName === 'Mixi', 'pcg_list': pcg.bucketName !== 'Mixi' }">
                  <div v-on:click="peckaPkg(pcg.bucketName)">
                    <span>
                        <span class="pcg-title">{{pcg.pkgName}}</span><br/>
                        <!-- <div v-html="pcg.newDesc.infoText" style="width:72%"></div> -->
                        <p></p>
                        <div v-html="pcg.newDesc.infoText"></div>
                    </span>
                    <span v-if="!pcg.hidePrice" class="pcg_active fet">AKTÍVNY</span>
                    <span v-if="pcg.hidePrice && pcg.bucketName === 'Mixi'" class="pcg_right_mixi" style="top:1.6rem"><span>od </span><span v-html="states.mixiPrice" style="font-size:1.7rem;"></span></span>
                  </div>
                <div v-for="mixiProl in baseView.mixiProlong" :key="mixiProl.readable">
                  <div class="mixi-prol-pcg-p">
                    <div><strong v-text="mixiProl.readable" /> sa obnoví {{ mixiProl.dateReadable }}</div>
                    <div v-on:click.prevent="handleMixiProlPecka('stopProl', mixiProl)">Vypnúť automatické predĺženie <img src="@/assets/img/ico_arrow_next_disabled.png" /></div>
                  </div>
                </div>
                </div>
            </div>
          <hr class="cros2 bottom">
          <p></p>
        </div>
        <h2>DÁTOVÉ BALÍČKY</h2>
            <div v-for="pcg in pkgTypes.data" :key="pcg.bucketName">
                <hr class="cros1">
                <div class="pcg_list" v-on:click="peckaPkg(pcg.bucketName)">
                    <span>
                        <span class="pcg-title">{{pcg.readable}}</span><br/>
                        <div v-html="pcg.newDesc.infoText" style="width:82%"></div>
                        <div v-html="pcg.newDesc.valText"></div>
                    </span>
                    <span v-if="!pcg.hidePrice" v-bind:class="{ pcg_active: pcg.isActive, fet: pcg.isActive, pcg_price: !pcg.isActive }" v-text="formatPrice(pcg.price, !pcg.isActive)"></span>
                </div>
            </div>
          <hr class="cros1">

          <p></p>
        <h2>VOLANIA</h2>
            <div v-for="pcg in pkgTypes.voice" :key="pcg.bucketName">
                <hr class="cros1">
                <div class="pcg_list" v-on:click="peckaPkg(pcg.bucketName)">
                    <span>
                        <span class="pcg-title">{{pcg.readable}}</span><br/>
                        <div v-html="pcg.newDesc.infoText" style="width:82%"></div>
                        <div v-html="pcg.newDesc.valText"></div>
                    </span>
                    <span v-if="!pcg.hidePrice" v-bind:class="{ pcg_active: pcg.isActive, fet: pcg.isActive, pcg_price: !pcg.isActive }" v-text="formatPrice(pcg.price, !pcg.isActive)"></span>
                </div>
            </div>
          <hr class="cros1">

          <p></p>
        <h2>SMS</h2>
            <div v-for="pcg in pkgTypes.sms" :key="pcg.bucketName">
                <hr class="cros1">
                <div class="pcg_list" v-on:click="currPkg=peckaPkg(pcg.bucketName)">
                    <span>
                        <span class="pcg-title">{{pcg.readable}}</span><br/>
                        <div v-html="pcg.newDesc.infoText" style="width:82%"></div>
                        <div v-html="pcg.newDesc.valText"></div>
                    </span>
                    <span v-if="!pcg.hidePrice" v-bind:class="{ pcg_active: pcg.isActive, fet: pcg.isActive, pcg_price: !pcg.isActive }" v-text="formatPrice(pcg.price, !pcg.isActive)"></span>
                </div>
            </div>
          <hr class="cros1">
          <p>&nbsp;</p>
      </div>    
      </div>    
      <div v-if="states.rplnRel == 'T'">
        <div class="large-12 medium-12 small-12 columns"><p></p>
        <h2 v-if="showTypes['top'] && listTop[0]" v-text="listTop[0].readable"></h2>
          <div v-if="showTypes['top'] && listTop[0]" class="top-types">
            <div v-for="pcg in listTop" :key="pcg.bucketName" class="sPkg" v-bind:class="{ sPkgPass: pcg.oappOnly }">
              <div class="sub-content pcg-list" v-on:click="pcgVis(pcg.bucketName)">
                <div class="pcg-block-left">
                  <div class="radio">
                    <span v-bind:class="{ checked: pcg.isChecked}"><input type="radio"></span>
                  </div>
                </div>
                <div class="pcg-block-right">
                <span>
                <span class="pcg-title">{{pcg.pkgName}}<br/></span>
                  <div v-html="pcg.newDesc.infoText" style="width:66%"></div>
                </span>
                <span class="pcg_right_mixi"><span v-show="pcg.bucketName === 'Mixi'">od </span><span style="font-size:1.7rem;" v-html="states.mixiPrice"></span></span>
                </div>
              </div>
                <div v-show="pcg.isChecked" class="pkg_container">
                <div class="pkg_desc">
                  <span class="fet" v-show="!pcg.hidePrice">AKTÍVNY</span>
                  <div v-html="pcg.newDesc.longText"></div>
                </div>

                <div v-for="mixiProl in baseView.mixiProlong" :key="mixiProl.readable">
                  <div class="mixi-prol-pcg">
                    <div><strong v-text="mixiProl.readable" /> sa obnoví</div>
                    <div v-text="mixiProl.dateReadable" />
                  </div>
                  <a class="a_btn a_info a_mixiprol" v-on:click = "handleMixiProl('stopProl', mixiProl)" v-if="true" style="margin-top:1rem;">Vypnúť automatické predĺženie Mixi <span class="text-nowrap">na {{ mixiProl.days }} dní</span></a>
                </div>

                <a class="a_btn" v-show="pcg.newDesc.startAction" v-bind:class="{ 'a_init_action': !pcg.oappOnly, 'a_info': pcg.oappOnly }" v-on:click = "callAction('start'), states.pkgAction=pcg.bucketName" v-html="pcg.btnText"></a>
                </div>
            </div>
          </div>

        <h2 v-show="(showTypes['1d'] || showTypes['10d'] || showTypes['30d'] || showTypes['1y'])">DÁTOVÉ BALÍČKY</h2>
          <div v-for="pcg in list1y" :key="pcg.bucketName" v-bind:class="{ sPkg: !pcg.oappOnly && !pcg.isBenefit, sPkgZero: !pcg.oappOnly && pcg.isBenefit, sPkgPass: pcg.oappOnly }">
            <div class="sub-content pcg-list" v-on:click="pcgVis(pcg.bucketName)">
              <div class="pcg-block-left">
                <div class="radio">
                  <span v-bind:class="{ checked: pcg.isChecked}"><input type="radio"></span>
                </div>
              </div>
              <div class="pcg-block-right">
              <span>
              <span class="pcg-title">{{pcg.readable}}<br/></span>
                      <div v-html="pcg.newDesc.infoText" style="width:74%"></div>
              </span>
              <span class="fet" v-show="pcg.isActive" v-html="pcg.newDesc.currStateText"></span>
              <span v-if="!pcg.hidePrice" class="pcg_right" :style="{ 'color': (pcg.isZero || pcg.isBenefit ? '#e20074' : '#222222') }" v-html="formatPrice(pcg.price, !pcg.isActive)">
              </span>
              </div>
            </div>
              <div v-show="pcg.isChecked" class="pkg_container">
              <div class="pkg_desc">
                <div v-html="pcg.newDesc.longText"></div>
                <p></p>
                <div v-show="!pcg.oappOnly">Platí do <strong><span v-html="pcg.newDesc.valText"></span></strong></div>
              </div>
              <a class="a_btn" v-show="pcg.newDesc.startAction" v-bind:class="{ a_action: !pcg.oappOnly, a_info: pcg.oappOnly }" v-on:click = "callAction('start'), states.pkgAction=pcg.bucketName" v-html="pcg.btnText"></a>
              <a class="a_btn a_info" v-on:click = "callAction('stopProl')" v-if="pcg.prolongable && pcg.hasNext && !pcg.oappOnly" style="margin-top:1rem;">Vypnúť automatické predĺženie</a>
              </div>
          </div>
          <div class="pcg-sub" v-show="showTypes['1d']">
            <div class="sub-heading">
              Platnosť: 1 deň
            </div>
            <div v-for="pcg in list1d" :key="pcg.bucketName" v-bind:class="{ sPkg: !pcg.oappOnly && !pcg.isBenefit, sPkgZero: !pcg.oappOnly && pcg.isBenefit, sPkgPass: pcg.oappOnly }">
              <div class="sub-content pcg-list" v-on:click="pcgVis(pcg.bucketName)">
                <div class="pcg-block-left">
                  <div class="radio">
                    <span v-bind:class="{ checked: pcg.isChecked}"><input type="radio"></span>
                  </div>
                </div>
                <div class="pcg-block-right">
                <span>
                <span class="pcg-title">{{pcg.readable}}<br/></span>
                        <div v-html="pcg.newDesc.infoText" style="width:74%"></div>
                </span>
                <span class="fet" v-show="pcg.isActive" v-html="pcg.newDesc.currStateText"></span>
                <span class="pcg_right" :style="{ 'color': (pcg.isZero || pcg.isBenefit ? '#e20074' : '#222222') }" v-if="!pcg.hidePrice" v-html="formatPrice(pcg.price, !pcg.isActive)">
                </span>
                </div>
              </div>
                <div v-show="pcg.isChecked" class="pkg_container">
                <div class="pkg_desc">
                  <div v-html="pcg.newDesc.longText"></div>
                  <p></p>
                  <div v-show="!pcg.oappOnly">Platí do <strong><span v-html="pcg.newDesc.valText"></span></strong></div>
                </div>
                <a class="a_btn" v-show="pcg.newDesc.startAction" v-bind:class="{ a_action: !pcg.oappOnly, a_info: pcg.oappOnly }" v-on:click = "callAction('start'), states.pkgAction=pcg.bucketName" v-html="pcg.btnText"></a>
                <a class="a_btn a_info" v-on:click = "callAction('stopProl')" v-if="pcg.prolongable && pcg.hasNext && !pcg.oappOnly" style="margin-top:1rem;">Vypnúť automatické predĺženie</a>
                </div>
            </div>
          </div>
          <div class="pcg-sub" v-show="showTypes['10d']">
            <div class="sub-heading">
              Platnosť: 10 dní
            </div>
            <div v-for="pcg in list10d" :key="pcg.bucketName" v-bind:class="{ sPkg: !pcg.oappOnly && !pcg.isBenefit, sPkgZero: !pcg.oappOnly && pcg.isBenefit, sPkgPass: pcg.oappOnly }">
              <div class="sub-content pcg-list" v-on:click="pcgVis(pcg.bucketName)">
                <div class="pcg-block-left">
                  <div class="radio">
                    <span v-bind:class="{ checked: pcg.isChecked}"><input type="radio"></span>
                  </div>
                </div>
                <div class="pcg-block-right">
                <span>
                <span class="pcg-title">{{pcg.readable}}<br/></span>
                        <div v-html="pcg.newDesc.infoText" style="width:74%"></div>
                </span>
                <span class="fet" v-show="pcg.isActive" v-html="pcg.newDesc.currStateText"></span>
                <span v-if="!pcg.hidePrice" class="pcg_right" :style="{ 'color': (pcg.isZero || pcg.isBenefit ? '#e20074' : '#222222') }" v-html="formatPrice(pcg.price, !pcg.isActive)">
                </span>
                </div>
              </div>
                <div v-show="pcg.isChecked" class="pkg_container">
                <div class="pkg_desc">
                  <div v-html="pcg.newDesc.longText"></div>
                  <p></p>
                  <div v-show="!pcg.oappOnly">Platí do <strong><span v-html="pcg.newDesc.valText"></span></strong></div>
                </div>
                <a class="a_btn" v-show="pcg.newDesc.startAction" v-bind:class="{ a_action: !pcg.oappOnly, a_info: pcg.oappOnly }" v-on:click = "callAction('start'), states.pkgAction=pcg.bucketName" v-html="pcg.btnText"></a>
                <a class="a_btn a_info" v-on:click = "callAction('stopProl')" v-if="pcg.prolongable && pcg.hasNext && !pcg.oappOnly" style="margin-top:1rem;">Vypnúť automatické predĺženie</a>
                </div>
            </div>
          </div>
          <div class="pcg-sub" v-show="showTypes['30d']">
            <div class="sub-heading">
              Platnosť: 30 dní
            </div>
            <div v-for="pcg in list30d" :key="pcg.bucketName" v-bind:class="{ sPkg: !pcg.oappOnly && !pcg.isBenefit, sPkgZero: !pcg.oappOnly && pcg.isBenefit, sPkgPass: pcg.oappOnly }">
              <div class="sub-content pcg-list" v-on:click="pcgVis(pcg.bucketName)">
                <div class="pcg-block-left">
                  <div class="radio">
                    <span v-bind:class="{ checked: pcg.isChecked}"><input type="radio"></span>
                  </div>
                </div>
                <div class="pcg-block-right">
                <span>
                <span class="pcg-title">{{pcg.readable}}<br/></span>
                        <div v-html="pcg.newDesc.infoText" style="width:74%"></div>
                </span>
                <span class="fet" v-show="pcg.isActive" v-html="pcg.newDesc.currStateText"></span>
                <span v-if="!pcg.hidePrice" class="pcg_right" :style="{ 'color': (pcg.isZero || pcg.isBenefit ? '#e20074' : '#222222') }" v-html="formatPrice(pcg.price, !pcg.isActive)">
                </span>
                </div>
              </div>
                <div v-show="pcg.isChecked" class="pkg_container">
                <div class="pkg_desc">
                  <div v-html="pcg.newDesc.longText"></div>
                  <p></p>
                  <div v-show="!pcg.oappOnly">Platí do <strong><span v-html="pcg.newDesc.valText"></span></strong></div>
                </div>
                <a class="a_btn" v-show="pcg.newDesc.startAction" v-bind:class="{ a_action: !pcg.oappOnly, a_info: pcg.oappOnly }" v-on:click = "callAction('start'), states.pkgAction=pcg.bucketName" v-html="pcg.btnText"></a>
                <a class="a_btn a_info" v-on:click = "callAction('stopProl')" v-if="pcg.prolongable && pcg.hasNext && !pcg.oappOnly" style="margin-top:1rem;">Vypnúť automatické predĺženie</a>
                </div>
            </div>
          </div>

        <div v-show="showTypes['voice']">
          <h2>VOLANIA</h2>
            <div v-for="pcg in pkgTypes.voice" :key="pcg.bucketName" v-bind:class="{ sPkg: !pcg.oappOnly, sPkgPass: pcg.oappOnly }">
              <div class="sub-content pcg-list" v-on:click="pcgVis(pcg.bucketName)">
                <div class="pcg-block-left">
                  <div class="radio">
                    <span v-bind:class="{ checked: pcg.isChecked}"><input type="radio"></span>
                  </div>
                </div>
                <div class="pcg-block-right">
                <span>
                <span class="pcg-title">{{pcg.readable}}<br/></span>
                        <div v-html="pcg.newDesc.infoText" style="width:74%"></div>
                </span>
                <span class="fet" v-show="pcg.isActive" v-html="pcg.newDesc.currStateText"></span>
                <span v-if="!pcg.hidePrice" class="pcg_right" v-html="formatPrice(pcg.price, !pcg.isActive)">
                </span>
                </div>
              </div>
                <div v-show="pcg.isChecked" class="pkg_container">
                <div class="pkg_desc">
                  <div v-html="pcg.newDesc.longText"></div>
                  <p></p>
                  <div v-show="!pcg.oappOnly">Platí do <strong><span v-html="pcg.newDesc.valText"></span></strong></div>
                </div>
                <a class="a_btn" v-show="pcg.newDesc.startAction" v-bind:class="{ 'a_init_action': !pcg.oappOnly, 'a_info': pcg.oappOnly }" v-on:click = "callAction('start'), states.pkgAction=pcg.bucketName" v-html="pcg.btnText"></a>
                <a class="a_btn a_info" v-on:click = "callAction('stopProl')" v-if="pcg.prolongable && pcg.hasNext && !pcg.oappOnly" style="margin-top:1rem;">Vypnúť automatické predĺženie</a>
                </div>
            </div>
          </div>
          <p>&nbsp;</p>
        </div> 
      </div> 
      </div>    
      <div v-else class="row"><p></p><div class="text-center large-12 medium-12 small-12 columns"><label v-html="tpl('package.unsupportedRpln')"></label></div></div>

  </div>
  <activations v-if="states.activationsView" :states="states" :productdetail="productdetail" :tplData="tplData" :pkgDef="pkgDef" :nextPacks="baseView.nextPacks"></activations>
  <mixiMenu v-if="states.mixiMenuView" :states="states" :productdetail="productdetail" :tplData="tplData" :pkgDef="pkgDef" :nextPacks="baseView.nextPacks" :mixiEligibleFull="mixiEligibleFull" :mixiActiveBq="mixiActiveBq"></mixiMenu>
</div>

</template>

<script>
import moment from 'moment'
import Activations from '@/components/balickyaction'
import mixiMenu from '@/components/miximenu'
import pkgDef from '@/assets/js/pkgDef'
import { computeMixiProlong } from '@/services'

export default {
  name: 'balicky',
  components: {
    Activations, mixiMenu
  },
  data () {
    return {
      msg: 'Balíčky',
      tplData: {},
      tpl: function(tpath) {
        const inObj = _.get(this.tplData, tpath); var res = null
        if (inObj) {res = inObj
        } else {
          res = tpath.toString()
        } return res
      },
      states: {
        viewAllow: false, showWait: true, showFail: false, isPecka: false, rplnRel: null, mainView: true, activationsView: false, isDirect: false, directAction: 'stopProl', currPkg: {}, daysAcc: [], onServerError: false, mixiMenuView: false, mixiPrice: '0,75 €', mixiProl: {}
      },
      msisdn: '',
      productdetail: {},
      pkgDef: pkgDef,
      pkgTypes: { data: [], sms: [], voice: [], top: []},
      baseView: {
        nextPacks: [], mixiProlong: []
      },
      showTypes: { "1d": true, "10d": true, "30d": true, "1y": true, voice: true, top: true },
      mixiEligibleFull: [],
      mixiActiveBq: null
    }
  },
  mounted: function() {
  },
  created: function() {
    var that = this

    if (document.getElementById("msisdnTextSpan") === null) {
      var msisdnTextSpan = document.createElement("span")
      msisdnTextSpan.id = "msisdnTextSpan"
      var msisdnTemp = document.getElementById("jsHolder")
      msisdnTemp.appendChild(msisdnTextSpan)
    }  else {
      var msisdnTextSpan = document.getElementById("msisdnTextSpan")
    }

    var productDetailAllow = false, tplDataAllow = false;

    if (_.isEmpty(this.$store.state.productdetail)) {
      that.$store.dispatch('refreshProductDetail').then(() => {
       if (that.$store.state.httpCodes.productdetail === 200) {
          that.productdetail = that.$store.state.productdetail
          that.msisdn = that.$store.state.productdetail.msisdn
          msisdnTextSpan.innerHTML = '0' + that.msisdn.toString().substring(3)
       }        

       if (that.$store.state.httpCodes.productdetail === 403) {
          window.location.href = '/prihlasenie/?url=' + encodeURIComponent(that.$router.history.base + that.$route.fullPath)
       } else if (that.$store.state.httpCodes.productdetail === 400) {
          // window.location.href = '/datanavyse'
          window.location.href = '/prihlasenie/?url=' + encodeURIComponent(that.$router.history.base + that.$route.fullPath)
       } else if (that.$store.state.httpCodes.productdetail === 502) {
          that.states.showFail = true
          that.states.onServerError = true
       } else if (_.isEmpty(that.productdetail)) {
            that.states.showFail = true
       } else {
            productDetailAllow = true
            if (tplDataAllow) {
              that.states.viewAllow = true
              that.startMain()
            }
          }
      })
    } else {
        that.productdetail = that.$store.state.productdetail
        that.msisdn = that.$store.state.productdetail.msisdn
        msisdnTextSpan.innerHTML = '0' + that.msisdn.toString().substring(3)
        that.states.viewAllow = true
        productDetailAllow = true
    }
    if (_.isEmpty(this.$store.state.tplData)) {
      that.$store.dispatch('refreshTplData').then(() => {
        that.tplData = that.$store.state.tplData
        tplDataAllow = true
        if (productDetailAllow) {
          that.states.viewAllow = true
          that.startMain()
        }
      });
    } else {
        that.tplData = that.$store.state.tplData
        that.states.viewAllow = true
        tplDataAllow = true
        that.startMain()
    }
  },
  methods: {
    httpEligible: async function() {
      let a 
      this.states.viewAllow = false
      await this.$http.get(this.$store.state.elgSrc, { headers: { 'x-added-pkg': this.$route.query['magenta-moments'] || 'none' }})
      .then(function (resp) {
         a = { data: resp.data, status: resp.status }
      })
      .catch(function(err){
         a = { data: err.response.data, status: err.response.status }
      })
      return a
    },
    startMain: async function() {
      var that = this, eligData = {};
      if (!_.isEmpty(this.$store.state.localEligData)) {
        eligData = { data: this.$store.state.localEligData, status: 200 }
      } else {
        eligData = await this.httpEligible()
        that.$store.commit('localEligData', eligData.data);
      }
      that.mixiEligibleFull = eligData.data;
      this.states.viewAllow = true
      var daysNom = ['nedeľa', 'pondelok', 'utorok', 'streda', 'štvrtok', 'piatok', 'sobota']
      var daysAcc = ['nedele', 'pondelka', 'utorka', 'stredy', 'štvrtka', 'piatka', 'soboty']
      this.states.daysAcc = daysAcc
      that.pkgTypes = { data: [], sms: [], voice: [], top: []}
      that.productdetail = that.$store.state.productdetail
      if (that.tplData.package) {
      if (_.isObject(that.tplData.package.name)) {
        _.assign(that.namesMap, that.tplData.package.name)
      }
      }

      if (((that.productdetail.product.productName).toLowerCase()).indexOf('pecka') !== -1) {
        that.states.isPecka = true
        that.states.rplnRel = "P"
        that.pkgDef = that.pkgDef.pecka
      } else if (((that.productdetail.product.productName).toLowerCase()).indexOf('t karta') !== -1) {
        that.states.isPecka = true
        that.states.rplnRel = "T"
        that.pkgDef = that.pkgDef.tkarta
        if (eligData.status == 403) {
          window.location.href = "/prihlasenie" + window.location.search
          return false
        }
      }

      if (eligData.status != 200) {
        that.pkgDef = [];
      }

    if (that.states.isPecka) {
      var selectPkg = that.$route.query.pkg, selectExists = false, selectName = "", mixiPrices = [];
      var mixiSet = false;
      that.pkgDef.forEach(function(tmpv){
        if (selectPkg && tmpv.offerBName) {
        if (selectPkg.toLowerCase().search(tmpv.offerBName.toLowerCase()) > -1) {
            selectExists = true
            if (tmpv.oappOnly) {
              tmpv.oappOnly = false
              tmpv.btnText = "Aktivovať"
            }
            selectName = tmpv.offerBName
            tmpv.isChecked = true;
            that.pcgVis(tmpv.bucketName, true)
        }
        } else if (tmpv.offerBName === 'Mixi') {
            tmpv.isChecked = true;
        }
      })
      that.pkgDef.forEach(function(dv){
        if (that.tplData.package) {
          dv.desc = that.tplData.package[(dv.bucketName.toLowerCase().replace(/ /g, ''))]
          if (!dv.readable) {
            var bName = dv.bucketName
            if ((/free data social/i).test(bName)) {
              bName = "FD-SOCIAL"
            }
            if ((/free data chat/i).test(bName)) {
              bName = "FD-CHAT"
            }
            dv.readable = that.tplData.package.name[bName] || bName
          }
        }
          if (dv.isChecked) {
            that.pcgVis(dv.bucketName, true)
          }
          dv.newDesc = {}
          dv.newDesc = _.clone(dv.desc);

          if (that.states.rplnRel == "T") {
            if (dv.paralellDaysAdd == 0) {
            dv.newDesc.valText = 'dnes, '+ daysNom[(moment(that.productdetail.timeStamp).format('d'))] +' '+ moment(that.productdetail.timeStamp).format('D.M.YYYY') + " 23:59"
            } else {
            dv.newDesc.valText = daysAcc[(moment(that.productdetail.timeStamp).add((dv.paralellDaysAdd || 0), 'days').format('d'))] + ', ' + moment(that.productdetail.timeStamp).add((Math.round(parseInt(dv.paralellDaysAdd || 0))) * 24, 'hour').format('D.M.YYYY H:mm')
            }
            dv.newDesc.currStateText = "NEAKTÍVNY"
            if ((that.$route.query.override == "1") || (that.$store.state.forceOverride)) {
              if (dv.oappOnly) {
                dv.btnText = "Aktivovať"
              }
              dv.oappOnly = false
            }
            if (dv.oappOnly && that.tplData.package) {
              dv.newDesc.longText = "<strong>" + that.tplData.package.oappText + "</strong>"
            }
            dv.isZero = false;
            if ((eligData.status == 200) && (!_.isEmpty(eligData.data))) {
              _.forEach(eligData.data, function(ev, ek){
                if (dv.offerBName == ev.bucketName) {
                  dv.price = ev.price
                  dv.isZero = ev.price == 0;
                  if (selectExists) {
                    if (selectName == dv.offerBName) {
                      that.pkgTypes[dv.type].push(dv)
                    }
                  } else {
                  that.pkgTypes[dv.type].push(dv)
                  }
                }
                if ((dv.offerBName === 'Mixi') && (!mixiSet)) {
                  const fromMixi = _.filter(that.productdetail.mixMenu, function(m) { return m.bucketName === ev.bucketName || m.bucketName + '_M1' === ev.bucketName });
                  if (!_.isEmpty(fromMixi)) {
                      dv.hidePrice = !that.mixiActive();
                      that.pkgTypes[dv.type].push(dv);
                      mixiSet = true;
                  }
                }
                if (dv.offerBName === 'Mixi') {
                  const fromMixiPrice = _.filter(that.productdetail.mixMenu, function(m) { return m.bucketName === ev.bucketName || m.bucketName + '_M1' === ev.bucketName });
                  if (!_.isEmpty(fromMixiPrice)) {
                    mixiPrices.push(ev)
                  }
                }
              })
            } else {
              if (selectExists) {
                if (selectName == dv.offerBName) {
                  that.pkgTypes[dv.type].push(dv)
                }
              } else {
              that.pkgTypes[dv.type].push(dv)
              }            
            }
            dv.newDesc.startAction = true;
          } else {
            if ((eligData.status == 200) && (!_.isEmpty(eligData.data))) {
              if (dv.skipOrderResponse) {
                _.forEach(eligData.data, function(ev, ek){
                  if ((dv.bucketName) && (dv.bucketName == ev.bucketName)) {
                    dv.price = ev.price
                  }
                })
                that.pkgTypes[dv.type].push(dv)
              } else {
                _.forEach(eligData.data, function(ev, ek){
                  if ((dv.bucketName) && (dv.bucketName == ev.bucketName)) {
                    dv.price = ev.price
                    that.pkgTypes[dv.type].push(dv)
                  }
                  if ((dv.bucketName === 'Mixi') && (!mixiSet)) {
                    const fromMixi = _.filter(that.productdetail.mixMenu, function(m) { return m.bucketName === ev.bucketName || m.bucketName + '_M1' === ev.bucketName });
                    if (!_.isEmpty(fromMixi)) {
                      dv.price = ev.price,
                      dv.hidePrice = !that.mixiActive();
                      if (dv.oappOnly) {
                        dv.newDesc.valText = "<span class='oapp-link'>" + that.tplData.package.oappText + "</span>";
                      }
                      that.pkgTypes[dv.type].push(dv);
                      mixiSet = true;
                    }
                  }
                  if (dv.bucketName === 'Mixi') {
                    const fromMixiPrice = _.filter(that.productdetail.mixMenu, function(m) { return m.bucketName === ev.bucketName || m.bucketName + '_M1' === ev.bucketName });
                    if (!_.isEmpty(fromMixiPrice)) {
                      mixiPrices.push(ev)
                    }
                  }
                })
              }
            } else {
              that.pkgTypes[dv.type].push(dv)
            }
          }
      });    
      this.baseView.mixiProlong = computeMixiProlong(that.productdetail);
      if (selectExists && selectName === 'Mixi') {
        this.states.pkgAction = selectName;
        this.$router.replace({query: {}});
        this.callAction('start');

      }
      if (this.states.rplnRel !== "T" && selectPkg && selectPkg.toLowerCase() === 'mixi' && mixiSet) {
        this.$router.replace({query: {}});
        this.peckaPkg('Mixi');
      }
    } else {
      if ((eligData.status == 200) && (!_.isEmpty(eligData.data))) {
          _.forEach(eligData.data, function(ev, ek){
              const fromMixi = _.filter(that.productdetail.mixMenu, function(m) { return m.bucketName === ev.bucketName || m.bucketName + '_M1' === ev.bucketName });
              if (!_.isEmpty(fromMixi)) {
                mixiSet = true;
              }
          })
        }
        if (mixiSet) {
          that.pkgDef = that.pkgDef.pecka;
          this.$store.commit('updateOnlyMixPkg', true);
          if (!_.isEmpty(this.$route.query)) {
            this.$router.replace({query: {}})            
          }
          this.peckaPkg('Mixi');
        } else {
          this.$store.commit('setOldRpln', true);
          this.$router.replace('/data');
        }
    }
    const checkZero = _.sortBy(_.map(mixiPrices, 'price'));
    this.states.mixiPrice = this.formatPrice(((_.filter(checkZero, function(res) { return res !== 0 })) || 0.75), true);

      if (!_.isEmpty(_.filter(that.productdetail.product.subscriberWallets, { 'type': 'DataPackage' }))) {
        var dpIdent = _.filter(that.productdetail.product.subscriberWallets, { 'type': 'DataPackage' })[0]
        if ((dpIdent.buckets.endDate) && ((moment(dpIdent.buckets.endDate)) > (moment(that.productdetail.timeStamp)))) {
          if (dpIdent.buckets.name.indexOf("SURF1") === -1)  {
            that.baseView.nextPacks = _.concat(that.baseView.nextPacks, dpIdent)
          }
        }
      }

      if (!_.isEmpty(_.filter(that.productdetail.product.subscriberWallets, { 'type': 'DataPackage2' }))) {
        var dpIdent = _.filter(that.productdetail.product.subscriberWallets, { 'type': 'DataPackage2' })[0]
        if ((dpIdent.buckets.endDate) && ((moment(dpIdent.buckets.endDate)) > (moment(that.productdetail.timeStamp))) && (dpIdent.buckets.value != "") && (dpIdent.buckets.value != 0)) {
          that.baseView.nextPacks = _.concat(that.baseView.nextPacks, dpIdent)
        }
      }

      if (!_.isEmpty(_.filter(that.productdetail.product.subscriberWallets, { 'type': 'DataPackage3' }))) {
        var dpIdent = _.filter(that.productdetail.product.subscriberWallets, { 'type': 'DataPackage3' })[0]
        if ((dpIdent.buckets.endDate) && ((moment(dpIdent.buckets.endDate)) > (moment(that.productdetail.timeStamp))) && (dpIdent.buckets.value != "") && (dpIdent.buckets.value != 0)) {
          that.baseView.nextPacks = _.concat(that.baseView.nextPacks, dpIdent)
        }
      }

      if (!_.isEmpty(_.filter(that.productdetail.product.subscriberWallets, { 'type': 'DataPackagePD' }))) {
        var dpIdent = _.filter(that.productdetail.product.subscriberWallets, { 'type': 'DataPackagePD' })[0]
        if ((dpIdent.buckets.endDate) && ((moment(dpIdent.buckets.endDate)) > (moment(that.productdetail.timeStamp)))) {
          that.baseView.nextPacks = _.concat(that.baseView.nextPacks, dpIdent)
        }
      }

      if (!_.isEmpty(_.filter(that.productdetail.product.subscriberWallets, { 'type': 'DataPackageSSD' }))) {
        var dpIdent = _.filter(that.productdetail.product.subscriberWallets, { 'type': 'DataPackageSSD' })[0]
        if ((dpIdent.buckets.endDate) && ((moment(dpIdent.buckets.endDate)) > (moment(that.productdetail.timeStamp))) && (dpIdent.buckets.value != "") && (dpIdent.buckets.value != 0)) {
          that.baseView.nextPacks = _.concat(that.baseView.nextPacks, dpIdent)
        }
      }
      if (!_.isEmpty(that.filterDataBouquet())) {
        _.forEach(that.filterDataBouquet(), function(v){
          var currPkg = _.filter(that.pkgDef, { 'bucketName': v.name })[0]
          if (!_.isEmpty(currPkg)) {

            if (that.states.rplnRel == "T") {
            currPkg.newDesc.currStateText = "AKTÍVNY"
            if (!_.isEmpty(v.nextChargeDate)) {
              if (moment(v.nextChargeDate) > moment(that.productdetail.timeStamp)) {
                  currPkg.newDesc.valText = daysAcc[(moment(v.nextChargeDate).format('d'))] + ', ' + moment(v.nextChargeDate).format('D.M.YYYY H:mm')
                  currPkg.hasNext = true
              }
            } else {
                currPkg.newDesc.valText = daysAcc[(moment(v.endDate).format('d'))] + ', ' + moment(v.endDate).format('D.M.YYYY H:mm')
            }
            if (!currPkg.paralellPack) {
              currPkg.newDesc.startAction = false
            }
            }
            if (that.states.rplnRel == "P") {
            if (!_.isEmpty(v.nextChargeDate)) {
              if (moment(v.nextChargeDate) > moment(that.productdetail.timeStamp)) {
                  currPkg.newDesc.infoText = "Automaticky predlžovaný"
                  currPkg.newDesc.valText = "Obnoví sa "+ moment(v.nextChargeDate).format('D.M.YYYY H:mm')
                  currPkg.hasNext = true
              }
            } else {
              currPkg.newDesc.valText = "Platnosť do: "+ moment(v.endDate).format('D.M.YYYY H:mm')
            }
            }
          currPkg.isActive = true
          }
        })
      }
      if (this.states.rplnRel == "T") {

      if (this.pkgTypes.voice.length == 0) { this.showTypes['voice'] = false }

      if (!_.isEmpty(this.getFreeCalls2Num())) {
        var freeCalls2Num = this.getFreeCalls2Num(), nDates = [], nArr = [], that = this
        var calls2NumPkg = _.filter(this.pkgDef, { 'bucketName': 'FreeCalls2Num' })[0]
        calls2NumPkg.newDesc.currStateText = "AKTÍVNY"
        calls2NumPkg.isActive = true
        _.forEach(freeCalls2Num, function(nv,nk){
          nv.computedVal = moment(nv.endDate || nv.nextChargeDate)
          if (nv.nextChargeDate && (moment(nv.nextChargeDate) > moment(that.productdetail.timeStamp))) {
            calls2NumPkg.prolongable = true
          }
        })
        freeCalls2Num = _.reverse(_.sortBy(freeCalls2Num, [function(o) { return o.computedVal; }]));
        calls2NumPkg.numSorted = freeCalls2Num
        calls2NumPkg.newDesc.valText = daysAcc[(freeCalls2Num[0].computedVal.format('d'))] + ', ' + freeCalls2Num[0].computedVal.format('D.M.YYYY H:mm')
        if (freeCalls2Num.length >= 5) {
          calls2NumPkg.btnText = 'Nastavenie'
        }
      }
      }

      if (!_.isEmpty(that.baseView.nextPacks)) {
        _.forEach(that.baseView.nextPacks, function(v){
          v.name = v.buckets.name

          if ((/30d_1gb/i).test(v.name)) {
            v.name = "30D_1GB"
          }
          if ((/30d_2gbx/i).test(v.name)) {
            v.name = "30D_2GBx"
          }
          if ((/30d_3gb/i).test(v.name)) {
            v.name = "30D_3GB"
          }
          if ((/30d_4gb/i).test(v.name)) {
            v.name = "30D_4GB"
          }
          if ((/30d_5gb/i).test(v.name)) {
            v.name = "30D_5GB"
          }
          if ((/30d_6gb(?!x)/i).test(v.name)) {
            v.name = "30D_6GB"
          }
          if ((/30d_6gbx/i).test(v.name)) {
            v.name = "30D_6GBx"
          }
          if ((/30d_10gb(?![x, free])/i).test(v.name)) {
            v.name = "30D_10GB"
          }
          if ((/30d_10gbx/i).test(v.name)) {
            v.name = "30D_10GBx"
          }
          if ((/10d_unltd/i).test(v.name)) {
            v.name = "10D_UnLtd"
          }
          if ((/10d_chat/i).test(v.name)) {
            v.name = "10D_CHAT"
          }
          if ((/10d_social/i).test(v.name)) {
            v.name = "10D_SOCIAL"
          }
          if ((/free data social/i).test(v.name)) {
            v.name = "FD-SOCIAL"
          }
          if ((/free data chat/i).test(v.name)) {
            v.name = "FD-CHAT"
          }
          if ((/10d_1gb/i).test(v.name)) {
            v.name = "10D_1GB"
          }
          if ((/dc300/i).test(v.name)) {
            v.name = "DC300"
          }
          if ((/freecalls21/i).test(v.name)) {
            v.name = "FreeCalls21N"
          }
          if ((/giga1w/i).test(v.name)) {
            v.name = "GIGA1W"
          }
          if ((/giga3/i).test(v.name)) {
            v.name = "GIGA3"
          }
          if ((/giga5/i).test(v.name)) {
            v.name = "GIGA5"
          }
          if ((/giga2(?!4)/i).test(v.name)) {
            v.name = "GIGA2"
          }
          if ((/giga1(?!w)/i).test(v.name)) {
            v.name = "GIGA1M"
          }
          if ((/giga24/i).test(v.name)) {
            v.name = "GIGA24N"
          }
          if ((/giga6/i).test(v.name)) {
            v.name = "GIGA6N"
          }
          var currPkg = _.filter(that.pkgDef, { 'bucketName': v.name })[0]
          if (!_.isEmpty(currPkg)) {
            currPkg.isActive = true
            if (that.states.rplnRel == "P") {
            currPkg.newDesc.valText = "Platnosť do: "+ moment(v.buckets.endDate).format('D.M.YYYY H:mm')

            if ((currPkg.prolongable) && (v.buckets.nextChargeDate && (moment(v.buckets.nextChargeDate) > moment(that.productdetail.timeStamp)))) {
              currPkg.newDesc.infoText = "Automaticky predlžovaný"
              currPkg.newDesc.valText = "Obnoví sa "+ moment(v.buckets.endDate).format('D.M.YYYY H:mm')
              currPkg.hasNext = true
            }
          }
          if (that.states.rplnRel == "T") {

            if (currPkg.paralellDaysAdd == 0) {
            currPkg.newDesc.valText = 'dnes, '+ daysNom[(moment(that.productdetail.timeStamp).format('d'))] +' '+ moment(that.productdetail.timeStamp).format('D.M.YYYY') + " 23:59"
            } else {
            currPkg.newDesc.valText = daysAcc[(moment((v.buckets.endDate) || (v.buckets.nextChargeDate)).format('d'))] + ', ' + moment((v.buckets.endDate) || (v.buckets.nextChargeDate)).format('D.M.YYYY H:mm')
            }

            if (!currPkg.oappOnly) {
              if (parseInt(currPkg.price) === 0) {
                currPkg.btnText = currPkg.btnAltText;                 
              } else {
                currPkg.btnText = "Dokúpiť teraz";
              }
            }
            currPkg.newDesc.currStateText = "AKTÍVNY"
            if ((currPkg.prolongable) && (v.buckets.nextChargeDate && (moment(v.buckets.nextChargeDate) > moment(that.productdetail.timeStamp)))) {
              currPkg.hasNext = true
            }
            if (!currPkg.paralellPack) {
              currPkg.newDesc.startAction = false
            }
          }
          }

        })
      }
    },
    callAction: function(pAction) {
      if (this.states.currPkg.oappOnly) {
        window.location = "https://telekomsk.page.link/JioD"
      } else if (pAction === 'start' && this.states.pkgAction === 'Mixi') {
        this.states.mainView = false;
        this.states.mixiMenuView = true;
      } else {
      this.states.activationsView = true
      this.states.directAction = pAction
      this.states.isDirect = true
      }
    },
    handleMixiProl(pAction, mixiObj) {
      this.states.mixiProl = mixiObj;
      this.states.activationsView = true
      this.states.directAction = pAction
      this.states.isDirect = true
    },
    handleMixiProlPecka(pAction, mixiObj) {
      this.states.pkgAction = 'Mixi'
      this.handleMixiProl(pAction, mixiObj);
    },
    mixiActive: function() {
      var that = this, res = false;
      const mixiBq = _.uniq(_.map(this.productdetail.mixMenu, 'pkgType'));
      _.forEach(mixiBq, function(mv,mk){
        var dpIdent = _.filter(that.productdetail.product.subscriberWallets, function(m) { return m.type && m.type.startsWith(mv); });
        if (!_.isEmpty(dpIdent)) {
          try {
              _.forEach(dpIdent, function(iv) {
                if ((iv.buckets.endDate) && ((moment(iv.buckets.endDate)) > (moment(that.productdetail.timeStamp)))) {
                  that.mixiActiveBq = iv;
                  res = true;
                }
              })
          } catch(e) { console.log(e.message); }
        }
      });
      return res;
    },
    formatPrice: function (virgin, active) {
      if ((active) || (this.states.rplnRel == "T")) {
        return parseFloat(virgin).toFixed(2).toString().replace(/\./, ',') + " €"
      } else {
        return "Aktívny"
      }
    },
    filterDataBouquet: function () {
      var that = this
      var targetObj = {}, res = [], namesList = ['Free Data SOCIAL', 'Free Data CHAT', 'StreamOn Data Unlmtd', 'Free Voice Onnet', 'Free SMS SK']
      var wallets = this.productdetail.product.subscriberWallets
      if (!Array.isArray(wallets)) {
        wallets = [wallets]
      }
      wallets.forEach(function(v){
        if (v.type === undefined) {
          targetObj = v;
        }
      })
      if (!Array.isArray(targetObj.buckets)) {
        targetObj.buckets = [targetObj.buckets]
      }
      targetObj.buckets.forEach(function(tv){
        if (namesList.indexOf(tv.name) !== -1) {
          if (moment(that.productdetail.timeStamp) < moment(tv.endDate || tv.nextChargeDate)){
              res.push(tv)
          }
        }
      })
      return res
    },
    getFreeCalls2Num: function () {
      var that = this
      var targetObj = {}, res = []
      var wallets = this.productdetail.product.subscriberWallets
      if (!Array.isArray(wallets)) {
        wallets = [wallets]
      }
      wallets.forEach(function(v){
        if (v.type === undefined) {
          targetObj = v;
        }
      })
      if (!Array.isArray(targetObj.buckets)) {
        targetObj.buckets = [targetObj.buckets]
      }
      targetObj.buckets.forEach(function(tv){
        if ((tv.name).toLowerCase().indexOf("freecalls2num") !== -1) {
          if (moment(that.productdetail.timeStamp) < moment(tv.endDate || tv.nextChargeDate)){
              res.push(tv)
          }
        }
      })
      return res
    },
    pcgVis: function(currPkg, fromOffer) {
      var getResize = document.getElementById('containerMain'), tLen = this.pkgDef.length
      var that = this
      _.forEach(this.pkgDef, function(pv, pk){
        if (pv.bucketName == currPkg) {
          if (!fromOffer) {
            pv.isChecked = !pv.isChecked
          }
          if (pv.isChecked) {
            setTimeout(function(){
            if ((pk + 1) >= tLen) {
                document.getElementById('main').scrollTo(0, getResize.scrollHeight);
            }   
            }, 300)
            that.states.currPkg = pv
            that.states.pkgAction = pv.bucketName
          } else {
            getResize.style.paddingBottom = '0'            
          }
        } else {
          pv.isChecked = false
        }
      })
    },      
    filterBouquet: function (name) {
        var targetObj = {}, res = {}
        var wallets = this.productdetail.product.subscriberWallets
        if (!Array.isArray(wallets)) {
          wallets = [wallets]
        }
        wallets.forEach(function(v){
          if (v.type === undefined) {
            targetObj = v;
          }
        })
        if (!Array.isArray(targetObj.buckets)) {
          targetObj.buckets = [targetObj.buckets]
        }
        targetObj.buckets.forEach(function(tv){
          if (tv.name == name) {
            res = tv
          }
        })
        return res
    },
    peckaPkg: function(newState) {
      if (newState === 'Mixi') {
        this.states.mainView = false;
        this.states.mixiMenuView = true;
      } else {
        this.states.activationsView = true;
        this.states.pkgAction=newState;
      }
    }
  },
  computed: {
    list1d: function() {
      var res = []
      _.forEach(this.pkgTypes.data, function(v,k){
        if (v.subType == '1d') {
          res.push(v)
        }
      })
      if (res.length == 0) { this.showTypes['1d'] = false }
      return res
    },
    list10d: function() {
      var res = []
      _.forEach(this.pkgTypes.data, function(v,k){
        if (v.subType == '10d') {
          res.push(v)
        }
      })
      if (res.length == 0) { this.showTypes['10d'] = false }
      return res
    },
    list30d: function() {
      var res = []
      _.forEach(this.pkgTypes.data, function(v,k){
        if (v.subType == '30d') {
          res.push(v)
        }
      })
      if (res.length == 0) { this.showTypes['30d'] = false }
      return res
    },
    list1y: function() {
      var res = []
      _.forEach(this.pkgTypes.data, function(v,k){
        if (v.subType == '1y') {
          res.push(v)
        }
      })
      if (res.length == 0) { this.showTypes['1y'] = false }
      return res
    },
    listTop: function() {
      var res = []
      _.forEach(this.pkgTypes.top, function(v,k){
        res.push(v)
      })
      if (res.length == 0) { this.showTypes['top'] = false }
      return res
    }
  }
}
</script>

<style scoped>
 .fet {
   color: #E20074;
 }

.pcg-sub {
  border: 1px solid #E20074;
  position: relative;
  margin-bottom: 2rem;
}

.sub-content {
  width: 100%;
  display: flex;
  padding: 10px;
}

.pcg-sub .sub-heading {
  width: 100%;
  line-height: 2.4rem;
  color: #ffffff;
  background-color: #E20074;
  padding: 0 10px;
  font-size: 1.2rem;
  font-weight: bold;
}

.sPkg_w {
  margin-bottom: 1rem;
  background-color: #dbdbdb ;
  position: relative;
  box-shadow: 0 -2px 2px 0 #c4c4c4 inset
}

.sPkg_w:last-child {
  margin-bottom: 0;
  box-shadow: none
}

.sPkg {
  margin-bottom: 1rem;
  position: relative;
  background-color: #ededed;
  box-shadow: 0 -2px 2px 0 #c4c4c4 inset
}

.sPkgPass {
  margin-bottom: 1rem;
  position: relative;
  background-color: #f5f5f5;
  box-shadow: 0 -2px 2px 0 #c4c4c4 inset;
  color: #8f8f8f;
}

.sPkgZero {
  /* margin-bottom: 1rem;
  position: relative;
  border-top: 1px solid #ffffff;
  background-color: rgba(226, 0, 116, 0.85);
  box-shadow: 0 -2px 2px 0 #ffc4e1 inset;
  color: #ffffff; */
  margin-bottom: 1rem;
  position: relative;
  background-color: #ededed;
  box-shadow: 0 -2px 2px 0 #c4c4c4 inset
}

.pcg-sub .sPkg:last-child, .pcg-sub .sPkgPass:last-child, .pcg-sub .sPkgZero:last-child {
  margin-bottom: 0;
  box-shadow: none
}

.pcg_right {
  position: absolute;
  right: 10px;
  top: 0.9rem;
  font-size: 1.7rem;
}

.pcg_right_mixi {
  position: absolute;
  right: 10px;
  top: 0.9rem;
}

.pcg-block-left {
  flex: 0 0 40px;
  position: relative;
}

.pcg-block-right {
  flex: 1;
}

.pkg_desc {
  padding: 0 10px 10px 40px;
}

.pkg_container {
  padding: 10px 10px 4px 10px;
}

.pcg-title {
  text-transform: uppercase;
  width: 72%;
  display: inline-block;
}

.pcg_list_w.x-pecka .pcg_active.fet {
  color: #ececec;
  text-shadow: none;
}

.top-types {
  padding-bottom: 14px;
}

</style>
